export default {
    xs: 0,
    sm: 48,
    md: 64,
    lg: 75,
};
